import { render, staticRenderFns } from "./AddDisease.vue?vue&type=template&id=3da87114"
import script from "./AddDisease.vue?vue&type=script&lang=js"
export * from "./AddDisease.vue?vue&type=script&lang=js"
import style0 from "./AddDisease.vue?vue&type=style&index=0&id=3da87114&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports